import { I18n } from '@calendly/i18n';
import { Icon } from '@calendly/ui/components/icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MembersTable } from './members_table';
const wrapperCss = "w1kscegy";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const arrowIconCss = "alk6q7u";
const ArrowIcon = forwardRef((props, ref) => {
  const name = 'arrow-down-fill';
  return <Icon ref={ref} {...props} name={name} className={classNames(arrowIconCss, props.className)} />;
});
export const MembershipsList = ({
  memberships,
  slug
}) => <Wrapper>
    <p>
      <ArrowIcon />
      {I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.dropdown_text', {
      count: memberships.length
    })}
      {' '}
      <strong>
        /
        {slug}
      </strong>
    </p>
    <MembersTable memberships={memberships} />
  </Wrapper>;

require("./memberships_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./memberships_list.js");